import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DxDataGridModule, DxFormModule, DxTextBoxModule, DxValidatorModule } from 'devextreme-angular';
import { GpdButtonComponent } from 'src/app/components/gpd-button/gpd-button.component';
import { SvgIconComponent } from 'src/app/components/svg-icon/svg-icon.component';
import { AppGlobals } from 'src/app/app.globals';
import { RemunerationTag } from 'src/app/interfaces/entities/project-params';
import { TemplatesService } from 'src/app/services/templates.service';
import { ClickEvent } from 'devextreme/ui/button';

@Component({
    selector: 'app-section-remuneration-tags',
    templateUrl: './remuneration-tags.component.html',
    styleUrls: ['./remuneration-tags.component.css'],
    imports: [
        CommonModule,
        GpdButtonComponent,
        DxFormModule,
        DxTextBoxModule,
        DxDataGridModule,
        SvgIconComponent,
        DxValidatorModule,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SectionRemunerationTagsComponent implements OnInit {
  editData: {
    id: number | null;
    title: string;
  } | null = null;

  remunerationTags: RemunerationTag[] = [];

  validateUniqueTitle = (e: { value: string }) => {
    if (!e.value) return true;

    const normalizedValue = e.value.trim().toLowerCase();
    const isDuplicate = this.remunerationTags.some(
      tag => tag.id !== this.editData?.id && tag.title.trim().toLowerCase() === normalizedValue
    );

    return !isDuplicate;
  };

  constructor(
    private templateService: TemplatesService,
    private cdr: ChangeDetectorRef
  ) {}

  async ngOnInit() {
    await this.loadRemunerationTags();
  }

  async loadRemunerationTags() {
    try {
      const result = await this.templateService.getRemunerationTags({});

      if (!result.hasError) {
        this.remunerationTags = result.remunerationTags;
      } else {
        AppGlobals.ShowErrorMessage(result.feedback);
      }
    } catch (error) {
      AppGlobals.ShowErrorMessage('Failed to load remuneration tags');
    }
    this.cdr.markForCheck();
  }

  onAdd() {
    this.editData = {
      id: null,
      title: '',
    };
  }

  onEdit(item: RemunerationTag) {
    this.editData = {
      id: item.id,
      title: item.title,
    };
  }

  onCancel() {
    this.editData = null;
  }

  async onSave(e: ClickEvent) {
    try {
      var validationResult = e.validationGroup.validate();
      console.log(validationResult);
      if (!validationResult.isValid) {
        return;
      }
      const result = await this.templateService.writeRemunerationTag({
        tag: {
          id: this.editData.id,
          title: this.editData.title,
          isDeleted: false,
        },
      });

      if (!result.hasError) {
        this.editData = null;
        await this.loadRemunerationTags();
      } else {
        AppGlobals.ShowErrorMessage(result.feedback);
      }
    } catch (error) {
      AppGlobals.ShowErrorMessage('Failed to save Remuneration Tag');
    }
    this.cdr.markForCheck();
  }

  async deleteRemunerationTag(item: RemunerationTag) {
    try {
      const result = await this.templateService.writeRemunerationTag({
        tag: {
          ...item,
          isDeleted: true,
        },
      });

      if (!result.hasError) {
        await this.loadRemunerationTags();
      } else {
        AppGlobals.ShowErrorMessage(result.feedback);
      }
    } catch (error) {
      AppGlobals.ShowErrorMessage('Failed to delete remuneration tag');
    }
  }
}
